var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOverdueMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.951,49.962C19.461,49.582 15.424,46.42 11.524,42.447C7.146,37.987 2.744,30.112 2.744,30.112L2.745,30.112C1,27.144 0,23.688 0,20C0,8.962 8.962,0 20,0L20.129,0C31.108,0.07 40,9.005 40,20C40,23.688 39,27.144 37.255,30.112L37.256,30.112C37.256,30.112 32.854,37.987 28.476,42.447C24.316,46.685 20,50 20,50L19.951,49.962Z",
    style: {
      fill: "rgb(240,187,15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.951,49.962C19.461,49.582 15.424,46.42 11.524,42.447C7.146,37.987 2.744,30.112 2.744,30.112L2.745,30.112C1,27.144 0,23.688 0,20C0,8.962 8.962,0 20,0L20.129,0C31.108,0.07 40,9.005 40,20C40,23.688 39,27.144 37.255,30.112L37.256,30.112C37.256,30.112 32.854,37.987 28.476,42.447C24.316,46.685 20,50 20,50L19.951,49.962ZM35.51,29.137L35.531,29.099C37.101,26.428 38,23.318 38,20C38,10.104 29.997,2.063 20.123,2C20.123,2 19.994,2 20,2C10.066,2 2,10.066 2,20C2,23.318 2.899,26.428 4.469,29.099L4.49,29.136C4.49,29.136 8.727,36.743 12.951,41.046C15.669,43.814 18.454,46.179 20,47.441C21.543,46.181 24.33,43.816 27.049,41.046C31.273,36.743 35.51,29.136 35.51,29.136L35.51,29.137Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.12896,0,0,1.12896,-5.95582,-4.06196)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.991,
    cy: 20.879,
    r: 10.334,
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "2.66px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.475371,0,0,0.475371,10.4926,8.29939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,9.581L20,23.581",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "4.21px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.336138,0.336138,-0.336138,-0.336138,34.6492,20.7128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,14.804L20,23.581",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "4.21px"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverdueMarker);
export default __webpack_public_path__ + "static/media/overdueMarker.34a14866aa3f30a195e3843204d4e613.svg";
export { ForwardRef as ReactComponent };